module.exports = __webpack_public_path__ + "static/banner-7-b211b15631908552d55bf2774e77fbcd.jpg";